import napStyles from './../nap.json'

export default {
  infoColor: napStyles.colors.TertiaryDarkBlue,
  infoBgColor: napStyles.colors.TertiaryLightBlue,
  infoBorderColor: napStyles.colors.TertiaryMidBlue,
  successColor: napStyles.colors.TertiaryDarkGreen,
  successBgColor: napStyles.colors.TertiaryLightGreen,
  successBorderColor: napStyles.colors.TertiaryMidGreen,
  errorColor: napStyles.colors.TertiaryDarkRed,
  errorBgColor: napStyles.colors.TertiaryLightRed,
  errorBorderColor: napStyles.colors.TertiaryMidRed
}
